import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Pagination, Spin } from "antd";
import { BlogApi } from "../../api/blog";
const { Search } = Input;

function Blog() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [hasBlogs, setHasBlogs] = useState(false);

  const getBlogs = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        search: searchText,
        limit : 6
      };
      const { data } = await BlogApi(params);
      if (data?.status) {
        const pagination = data?.data?.pagination || {};
        const formattedData = data?.data?.blogs?.map((item) => ({
          id: item?.id,
          title: item?.title,
          desc: item?.desc,
          image: item?.image,
          created_at: new Date(item?.date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
        }));

        setBlogs(formattedData || []);
        setTotalRecords(pagination?.total || 0);
        setPageSize(pagination?.per_page || 6);
        if (!searchText && formattedData?.length > 0) {
          setHasBlogs(true);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBlogs();
  }, [page, searchText]);

  const handleSearch = (value) => {
    setSearchText(value);
    setPage(1);
  };

  return (
    <div className="website-container">
      {hasBlogs && (
        <div className="flex justify-end mb-4 md:px-5 px-2">
          <Search
            placeholder="Search blogs..."
            onSearch={handleSearch}
            enterButton
            allowClear
            style={{ width: 300 }}
          />
        </div>
      )}

      {loading ? (
        <p className="h-[500px] flex justify-center items-center">
          <Spin size="large" />
        </p>
      ) : (
        <>
          {blogs.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 px-4">
              <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-6">
                <rect x="20" y="30" width="120" height="100" rx="12" fill="#EAEDF2" />
                <rect x="32" y="42" width="96" height="76" rx="8" fill="#fff" stroke="#D1D5DB" strokeWidth="2" />
                <rect x="44" y="54" width="50" height="6" rx="3" fill="#0bafd4" opacity="0.6" />
                <rect x="44" y="66" width="72" height="4" rx="2" fill="#D1D5DB" />
                <rect x="44" y="76" width="72" height="4" rx="2" fill="#D1D5DB" />
                <rect x="44" y="86" width="50" height="4" rx="2" fill="#D1D5DB" />
                <rect x="44" y="98" width="30" height="8" rx="4" fill="#0bafd4" opacity="0.3" />
                <circle cx="120" cy="110" r="24" fill="#fff" stroke="#0bafd4" strokeWidth="3" />
                <line x1="138" y1="128" x2="148" y2="138" stroke="#0bafd4" strokeWidth="3" strokeLinecap="round" />
                <line x1="112" y1="110" x2="128" y2="110" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" />
                <line x1="120" y1="102" x2="120" y2="118" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <h4 className="text-[#191b1c] font-semibold text-xl mb-2">
                No Blogs Found
              </h4>
              <p className="text-[#7e8591] text-sm text-center max-w-md">
                {searchText
                  ? `No blogs match "${searchText}". Try a different search term.`
                  : "No blogs available at the moment. Please check back later."}
              </p>
            </div>
          ) : (
            <>
              <div className="grid lg:grid-cols-3 xl:gap-10 md:gap-8 gap-6 md:px-5 px-2 py-5">
                {blogs.map((data) => (
                  <div
                    className="blog-slider transition-transform transform hover:-translate-y-2"
                    key={data.id}
                  >
                    <div className="bg-white shadow-md rounded-2xl overflow-hidden flex flex-col h-full">
                      {data?.image && (
                        <div className="relative">
                          <img
                            src={data.image}
                            alt={data.title}
                            className="w-full h-72 object-cover"
                          />
                          {data.created_at && (
                            <span className="absolute top-0 right-0 bg-[#0bafd4] text-white text-xs font-semibold px-4 py-2 rounded-md shadow-md">
                              {data.created_at}
                            </span>
                          )}
                        </div>
                      )}

                      <div className="flex-1 flex flex-col p-4">
                        <h5 className="primary-color xl:text-[20px] md:text-[18px] text-[16px] font-semibold mb-3 leading-snug cursor-pointer">
                          {data.title}
                        </h5>
                        <div
                          className="mb-4 line-clamp-4 prose"
                          dangerouslySetInnerHTML={{ __html: data?.desc }}
                        />

                        <div className="flex items-center justify-between mt-auto">
                          <p
                            className="text-[#1e4387] font-medium text-sm hover:underline cursor-pointer"
                            onClick={() => navigate(`/blog/${data?.id}`)}
                          >
                            Read More →
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div className="flex justify-center mt-6">
                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={totalRecords}
                  showSizeChanger={false}
                  onChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Blog;
